import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Immediate scroll to top
    window.scrollTo(0, 0);
    
    // Also scroll the document element to ensure it works
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Delay scroll to handle async content loading
    const timeoutId = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      // Also scroll main element if it exists
      const mainElement = document.querySelector('main');
      if (mainElement) {
        mainElement.scrollTop = 0;
      }
    }, 100);
    
    // Another check after content likely loads
    const longerTimeoutId = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 300);
    
    return () => {
      clearTimeout(timeoutId);
      clearTimeout(longerTimeoutId);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop; 